import { useSelector } from 'react-redux';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import LastComponent from './common/lastComponent';

export default function CarHireSection({ componentProps }) {
  const { componentName, componentData, componentFullName, isLastComponent } =
    componentProps;
  const { theme } = useSelector((state) => state.ui);

  const component = componentData[componentFullName];

  return (
    <div className="flex mt-[30px] xs:mt-[40px] items-start">
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="relative z-10 hidden xs:inline"
      >
        <circle
          cx="25"
          cy="25"
          r="25"
          fill={theme.brandColour || DEFAULT_SECONDARY_COLOUR}
        />
        <path
          d="M31.92 18.01C31.72 17.42 31.16 17 30.5 17H19.5C18.84 17 18.29 17.42 18.08 18.01L16 24V32C16 32.55 16.45 33 17 33H18C18.55 33 19 32.55 19 32V31H31V32C31 32.55 31.45 33 32 33H33C33.55 33 34 32.55 34 32V24L31.92 18.01ZM19.5 28C18.67 28 18 27.33 18 26.5C18 25.67 18.67 25 19.5 25C20.33 25 21 25.67 21 26.5C21 27.33 20.33 28 19.5 28ZM30.5 28C29.67 28 29 27.33 29 26.5C29 25.67 29.67 25 30.5 25C31.33 25 32 25.67 32 26.5C32 27.33 31.33 28 30.5 28ZM18 23L19.5 18.5H30.5L32 23H18Z"
          fill="white"
        />
      </svg>

      <div className="xs:ml-[16px] mt-2">
        <div className="text-[22px] leading-[29.05px] font-medium flex xs:block items-center">
          <svg
            width="38"
            height="38"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="relative z-10 inline xs:hidden"
          >
            <circle
              cx="25"
              cy="25"
              r="25"
              fill={theme.primaryColour || DEFAULT_SECONDARY_COLOUR}
            />
            <path
              d="M31.92 18.01C31.72 17.42 31.16 17 30.5 17H19.5C18.84 17 18.29 17.42 18.08 18.01L16 24V32C16 32.55 16.45 33 17 33H18C18.55 33 19 32.55 19 32V31H31V32C31 32.55 31.45 33 32 33H33C33.55 33 34 32.55 34 32V24L31.92 18.01ZM19.5 28C18.67 28 18 27.33 18 26.5C18 25.67 18.67 25 19.5 25C20.33 25 21 25.67 21 26.5C21 27.33 20.33 28 19.5 28ZM30.5 28C29.67 28 29 27.33 29 26.5C29 25.67 29.67 25 30.5 25C31.33 25 32 25.67 32 26.5C32 27.33 31.33 28 30.5 28ZM18 23L19.5 18.5H30.5L32 23H18Z"
              fill="white"
            />
          </svg>
          <span className="ml-2.5 xs:ml-0">{componentName}</span>
        </div>
        <div className="max-w-[560px] text-[16px] leading-[31.2px] tracking-[0.25px] font-normal mt-[22px]">
          <strong>{component.pickupLocation}</strong>, Duration:{' '}
          {component.duration} days
          <br />
          {component.vehicle}
        </div>
      </div>

      {isLastComponent && <LastComponent />}
    </div>
  );
}
